// src/api/gcpTTS.ts
import { base64ToBlob } from "../utils/audioUtils";

export const gcpTextToSpeech = async (
  text: string,
  apiKey: string
): Promise<Blob> => {
  const url = `https://texttospeech.googleapis.com/v1/text:synthesize?key=${apiKey}`;
  const speechSpeed = text.length > 200 ? 0.93 : 1.0;
  //en-US-Casual-K
  //en-US-Journey-F
  const requestData = {
    input: { text },
    voice: {
      languageCode: "en-US",
      name: "en-US-Casual-K",
      ssmlGender: "MALE",
    },
    audioConfig: {
      audioEncoding: "MP3",
      speakingRate: speechSpeed, // Slows down the speech
    },
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `API Error: ${errorData.error?.message || response.statusText}`
      );
    }

    const data = await response.json();
    if (!data || !data.audioContent) {
      throw new Error("No audio content received from GCP TTS API");
    }

    // Create audio blob from base64
    const audioBlob = base64ToBlob(data.audioContent, "audio/mp3");

    // Verify blob size
    if (audioBlob.size === 0) {
      throw new Error("Generated audio blob is empty");
    }

    return audioBlob;
  } catch (error) {
    console.error("Text-to-Speech API error:", error);
    throw error;
  }
};
